<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item v-for="(item, index) in sBreadcrumbList" :key="item.path" :class="index + 1 == sBreadcrumbList.length ? '' : 'is-link'" @click.prevent.native="handleGo(item)">{{
				item.name
			}}</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
		data() {
			return {};
		},
		computed: {
			...mapGetters('Settings', ['sBreadcrumbList'])
		},
		methods: {
			handleGo(item) {
				if (item.back) {
					this.$router.back();
				} else if (item.path) {
					this.$router.push(item.path);
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.el-breadcrumb {
		font-size: 14px;
		height: 40px;
		line-height: 40px;
	}
	.el-breadcrumb__inner a,
	.el-breadcrumb__inner.is-link {
		font-weight: 400;
		color: #888888;
	}
	.el-breadcrumb__item:last-child .el-breadcrumb__inner {
		color: #333333;
	}

	.is-link {
		font-weight: 700;
		color: rgb(48, 49, 51);
		text-decoration: none;
		transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	}

	/deep/ .is-link:hover .el-breadcrumb__inner {
		color: rgb(64, 158, 255);
		cursor: pointer;
	}

	.el-breadcrumb-item:last-child .el-breadcrumb__separator {
		display: none;
	}
</style>
